import styled from 'styled-components';

export const Container = styled.button`
  width: 43px;
  height: 43px;
  background: ${(props) => props.theme.$primary_green};
  border: 0;
  border-radius: 4px;

  &:hover {
    background: ${(props) => props.theme.medium_green};
    cursor: pointer;

    .arrow {
      border-left: 7px solid ${(props) => props.theme.medium_green};
    }
  }

  .label {
    font-size: 25px;
    font-weight: lighter;
    color: white;
  }

  .arrow {
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid ${(props) => props.theme.primary_green};
    position: absolute;
    right: -6px;
    top: 14px;
  }
`;

export const Button = styled.button`
  height: 56px !important;
  background-color: #1f3e4f;
  background: #1f3e4f;

  .icon-ia-badge {
    font-weight: 500;
    padding: 1px 2px;
    font-size: 0.45rem;
    border-radius: 2px;
    bottom: 11px;
    left: 23px;
  }
`;
